import { sendGAEvent } from "@/components/google-analytics"
export const sendEventLog = (eventName: string, data?: any) => {
  sendGAEvent(eventName, data)
}
